import {React, useState} from 'react';
import './HomePageMainSection.css';
import GambotHomePage from '../../../assets/logoGam.png';
import { PiVideo } from "react-icons/pi";
import DemoMeetingPopup from './DemoMeetingPopup';
import common_usage from '../../../assets/blog_post/02/common usage.png'

const HomePageMainSection = () => {
  const scrollToNextSection = () => {
    const nextSection = document.getElementById('why-whatsapp');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div id="HomePageMainSection">
      <main className="mainHhomePage">
        <section className="section banner banner-section">
          <div className="container banner-column">
            <div className="banner-inner">
              <p className="PHomePageMainSection"> 
                <img className="logomainHhomePage" src={GambotHomePage} alt="GambotHomePageImage"/>
                <span className="boldTextMainHhomePage">Gambot</span> End-to-end WhatsApp Api Solution
              </p>
              <h1 className="heading-xl">Let Gambot work for you.</h1>
              {/* <p className="heading-x">הפלטפורמה המתקדמת לניהול תקשורת ארגונית בוואטסאפ</p> */}
              {/* <p className="heading-x">המערכת החכמה לניהול התקשורת הארגונית בוואטסאפ</p> */}
              <p className="heading-x">אנחנו עוזרים לעסקים להרוויח יותר בעזרת WhatsApp API</p>
              <p className="heading">💬 שירות לקוחות מהיר | 📣 שיווק מנצח | 💰 יותר מכירות | ⏳ פחות עבודה</p>

              <div className="mainHhomePage-btn-container">
                <button className="btn btn-darken btn-inline">סרטון הסבר <PiVideo /></button>
                <button
                  className="btn btn-secondary btn-inline"
                  onClick={() => setIsPopupOpen(true)}
                >
                  תיאום פגישת דמו <i className="bx bx-left-arrow-alt"></i>
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
      {isPopupOpen && (
        <DemoMeetingPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
      )}
    </div>
  );
};

export default HomePageMainSection;
